import { clsx } from 'clsx';

import { useUserTag } from './hooks';
import { ReactComponent as ProUserIcon } from 'assets/images/icons/prime.svg';
import { ReactComponent as NewUserIcon } from 'assets/images/icons/blue_star.svg';

import makeClasses from './UserTag.style';

import type { HTMLAttributes } from 'react';
import type { UserTagType } from 'shared/domain';

export function UserTag(props: Props) {
  const { variant = 'own', ...divProps } = props;

  const { lang } = useUserTag({ userTag: variant });

  const _classes = makeClasses({ userTag: variant });

  return (
    <div
      role='term'
      {...divProps}
      className={clsx(_classes.root, divProps.className)}
    >
      {variant === 'new' && <NewUserIcon />}
      {variant === 'pro' && <ProUserIcon />}
      <span>{lang.label}</span>
    </div>
  );
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  variant: UserTagType;
}
